import { useQuery } from 'react-query';
import { useLanguage, supportedLanguages } from './useLanguage';

// Checks query and stored value
const isLangSpanish = (language) => {
  return language === supportedLanguages.es
}

const pathToLang = (path, language) => {
  const isSpanish = isLangSpanish(language)
  return isSpanish
    ? `/es${path}`
    : path;
}

const keyToLang = (key, language) => {
  const isSpanish = isLangSpanish(language)
  return isSpanish
    ? `${key}Es`
    : key;
}

const useFetchGetData = (queryKey, queryPath, isMockData=false) => {
  const language = useLanguage();

  const key = keyToLang(queryKey, language);

  const query = useQuery(key, async () => {
    // adding a path to es requests
    const queryURL = pathToLang(queryPath, language)

    if (!isMockData)
    {
      const response = await fetch(queryURL);
      return response.json()
    }
    return {};
  });


  return query
};

const useFetchGetDataLangAgnostic = (queryKey, queryPath, isMockData=false) => {
  const key = queryKey

  const query = useQuery(key, async () => {
    const queryURL = queryPath

    if (!isMockData)
    {
      const response = await fetch(queryURL);
      return response.json()
    }
    return {};
  });


  return query
};

const useFetchPostData = (queryKey, pagePath, isMockData=false) => {
  const language = useLanguage();

  const key = keyToLang(queryKey, language);

  const bodyData = [
    {
        "requestId": "router",
        "action": "view",
        "uri": `${pathToLang('/router/translate-path', language)}?path=${pagePath}`,
        "headers": {
            "Content-Type": "application/vnd.api+json",
            "Accept": "application/json"
        }
    },
    {
        "requestId": "resolvedResource",
        "action": "view",
        "uri": "{{router.body@$.jsonapi.individual}}",
        "headers": {
            "Content-Type": "application/vnd.api+json",
            "Accept": "application/json"
        },
        "waitFor": [
            "router"
        ]
    }
  ]

  return useQuery(key, async () => {

    // adding a path to es requests
    const queryURL = pathToLang('/subrequests?_format=json', language);

    if (!isMockData)
    {
      const response = await fetch(queryURL, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(bodyData)
      });

      const content = await response.json();
      return JSON.parse(content['resolvedResource#uri{0}'].body);
    }
    return {};
  });
};

const useFetchPostDataV2 = (queryKey, requestBody, isMockData=false, enabled=true) => {
  const language = useLanguage();

  // Changing request key to disable caching on refetch
  const key = keyToLang(queryKey, language);

  return useQuery(key, async () => {
    const queryURL = pathToLang('/subrequests?_format=json', language);

    if (!isMockData)
    {
      const modifiedRequestBody = JSON.parse(JSON.stringify(requestBody));
      modifiedRequestBody.forEach(request => {
        if (request.uri && request.uri.includes('/router/translate-path')) {
          request.uri = pathToLang(request.uri, language);
        }
      });

      const response = await fetch(queryURL, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(modifiedRequestBody)
      });
      const content = await response.json();
      return content;
    }
    return {};
  }, {enabled});
};


function setPath(request, path) {
  const body = JSON.parse(JSON.stringify(request));

  if (body[0]) {
    body[0].uri += path;
  }

  return body;
}

function setViewUrl(request, options) {
  const body = JSON.parse(JSON.stringify(request));

  if (body[0] && options.viewRelatedProduct) {
    let view = options.viewRelatedProduct?.display + '/' + options.viewRelatedProduct?.display;
    if (options.viewRelatedProduct["views-sort"]) {
      view += `?views-sort[${options.viewRelatedProduct['views-sort'].id}]=${options.viewRelatedProduct["views-sort"].value}`;
    }
    if (options.viewRelatedProduct["views-filter"]) {
      view += `&views-filter[${options.viewRelatedProduct['views-filter'].id}]=${options.viewRelatedProduct["views-filter"].value}`;
    }
    if (options.productId) {
      view += `&views-argument[]=${options.productId}`;
    }

    body[0].uri += view;
  }
  return body;
}

export {
  useFetchGetData,
  useFetchGetDataLangAgnostic,
  useFetchPostData,
  useFetchPostDataV2,
  setPath,
  setViewUrl
};
